import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';

interface PageTitleProps {
  headerId: string;
  headerValue?: any;
}

export const PageHeader = (
  { headerId, headerValue }: PageTitleProps,
) => (
  <Box id="page-title">
    <Typography
      variant="h1"
      fontWeight={600}
      lineHeight={1.4}
      textTransform="capitalize"
      color="#43509B"
      sx={theme => ({
        fontSize: '40px !important',
        [theme.breakpoints.down('tablet')]: {
          fontSize: '35px !important',
        },
        [theme.breakpoints.down('mobile')]: {
          fontSize: '30px !important',
        },
      })}
    >
      <FormattedMessage
        id={headerId}
        values={headerValue}
      />
    </Typography>
  </Box>
);
